import { languages } from '../constants/messages';

export const defaultLocale = 'en-US';

export const supportedLocales = Object.keys(languages);

export const locales = supportedLocales.map(locale => ({
  id: locale,
  name: languages[locale],
}));
